module.exports = __webpack_public_path__ + "img/123.23f6a945.png";